import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls } from "../../shared/seo/links";
import "./content.css";

/**
 * Visible breadcrumb, the same trail the page's BreadcrumbList JSON-LD and
 * the server renderer describe. items: [{ name, path }], the last one is the
 * current page. tone "light" sits on a white card, "dark" on the navy hero.
 */
export default function Breadcrumbs({ items, tone = "light" }) {
  const { t } = useTranslation();
  if (!items || items.length === 0) return null;
  return (
    <nav className={`avc-breadcrumbs avc-breadcrumbs--${tone}`} aria-label={t("breadcrumb_label")}>
      <ol>
        {items.map((item, i) =>
          i === items.length - 1 ? (
            <li key={item.path} aria-current="page">
              {item.name}
            </li>
          ) : (
            <li key={item.path}>
              {/* The home page is another document (its own stylesheet direction): a plain link. */}
              {i === 0 ? <a href={urls.toHref(item.path)}>{item.name}</a> : <PathLink to={item.path}>{item.name}</PathLink>}
            </li>
          )
        )}
      </ol>
    </nav>
  );
}
